module.exports = __webpack_public_path__ + "static/media/19_r_wall_79.43_0.765ff2a0.png";